import AlergenIngredient from "./AlergenIngredient";
import VariacioIngredient from "./VariacioIngredient";

class Ingredient {
    constructor(
        public id= 0,
        public key= 0,
        public nom= "",
        public preu= 0,
        public cuina= "",
        public estat= 0,
        public tipus= "",
        public mesura= "",
        public alergia= 0,
        public proposta= "",
        public idProveidor1= "",
        public idProveidor2= 0,
        public proveidor1= "",
        public proveidor2= "",
        public minim_stock= 0,
        public fitxaTecnica= "",
        public fitxaTecnica2= "",
        public arrodoniment_comanda= 0,
        public arrodoniment_repartir= 0,
        public identificadorFitxaTecnica= "",
        public identificadorFitxaTecnica2= "",
        public alergen_ingredient: Array<AlergenIngredient> = [],
        public variacio_ingredient: Array<VariacioIngredient> = [],
    ) {
        this.id = id;
        this.key = key;
        this.nom = nom;
        this.preu = preu;
        this.cuina = cuina;
        this.estat = estat;
        this.tipus = tipus;
        this.mesura = mesura;
        this.alergia = alergia;
        this.proposta = proposta;
        this.idProveidor1 = idProveidor1;
        this.idProveidor2 = idProveidor2;
        this.proveidor1 = proveidor1;
        this.proveidor2 = proveidor2;
        this.minim_stock = minim_stock;
        this.fitxaTecnica = fitxaTecnica;
        this.fitxaTecnica2 = fitxaTecnica2;
        this.arrodoniment_comanda = arrodoniment_comanda;
        this.arrodoniment_repartir = arrodoniment_repartir;
        this.identificadorFitxaTecnica = identificadorFitxaTecnica;
        this.identificadorFitxaTecnica2 = identificadorFitxaTecnica2;
        this.alergen_ingredient = alergen_ingredient;
        this.variacio_ingredient = variacio_ingredient;
    }
}
export default Ingredient;
